// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Grid,
  SingleSelect,
} from '@fortress-technology-solutions/fortress-component-library/Molecules';
import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import messages from '../../messages';
import { useRecertType } from './hooks';
import { RECERT_TYPES } from './constants';

type Props = {
  editMode: boolean,
  program: string,
  recertTypes?: { [program: string]: string } | null,
  onChange: Function,
};

const RecertType = ({
  editMode,
  program,
  recertTypes,
  onChange,
}: Props): React$Node => {
  const { isEnabled, options, handleChange } = useRecertType({
    program,
    recertTypes,
    onChange,
  });

  if (!isEnabled) return null;

  const value = recertTypes?.[program] ?? RECERT_TYPES.FULL;

  return (
    <Grid item xs={12} sm={6}>
      <SingleSelect
        label={<FormattedMessage {...messages.recertType} />}
        InputLabelProps={{
          TooltipProps: {
            title: <FormattedMessage {...messages.recertTypeTooltip} />,
            children: <AlertInfoIcon />,
          },
        }}
        readOnly={!editMode}
        required
        name={`setup.recertTypes.${program}`}
        value={value}
        placeholder="---"
        options={options}
        onChange={handleChange}
      />
    </Grid>
  );
};

export default RecertType;
